gsap.registerPlugin(ScrollTrigger);

function initFadeIn() {

  const elements = document.querySelectorAll('.fade-in');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            autoAlpha: 0,
            yPercent: 5,
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                // toggleActions: 'play none none reverse',
                // markers: true
            }
        })
    })
  }
}

function initBG() {

  const main = document.querySelector('#main-content');
  const scrollColorElems = document.querySelectorAll("[data-bgcolor]");

  if (scrollColorElems) {

    scrollColorElems.forEach((colorSection, i) => {
      const prevBg = i === 0 ? "" : scrollColorElems[i - 1].dataset.bgcolor;

      ScrollTrigger.create({
        trigger: colorSection,
        // scroller: "#main-content",
        start: "top bottom",
        scrub: true,
        // markers: true,
        onEnter: () =>
          gsap.to(main, {
            backgroundColor: colorSection.dataset.bgcolor,
            overwrite: "auto"
          }),
        onLeaveBack: () =>
          gsap.to(main, {
            backgroundColor: prevBg,
            overwrite: "auto"
          })
      });
    });
    // gsap.to(main, {
    //     backgroundColor: '#F2F2F2',
    //     scrollTrigger: {
    //         trigger: el,
    //         start: 'top top',
    //         // end: 'top center',
    //         toggleActions: 'play none none reverse',
    //         // markers: true
    //     }
    // })
  }
}

function initUnstick() {

  const el = document.querySelector('.sticky-el');

  if (el) {
    gsap.to(el, {
        position: 'relative',
        scrollTrigger: {
          trigger: el.nextElementSibling,
            start: 'top top',
            // end: 'top center',
            toggleActions: 'play none none reverse',
            // markers: true
        }
    })
  }
}

function initUnstickFolders() {

  const el = document.querySelector('.folderflip_tag:nth-of-type(3)');
  const stickEls = document.querySelectorAll('.folderflip_tag');

  if (el) {
    gsap.to(el, {
        position: 'relative',
        scrollTrigger: {
          trigger: el,
            start: 'top 256px',
            // end: 'top center',
            toggleActions: 'play none none reverse',
            markers: true
        }
    })
  }
}

function headingSlide() {
  const elements = document.querySelectorAll('.home h1 span');
  if (elements) {
    elements.forEach((el, i) => {
        gsap.from(el, {
            height: 0,
            delay: 1.4,
            duration: 0.8,
            ease: "power2.inOut",
        })
    })
  }
}

function initScrollBackground() {

  const bgWrap = document.querySelector('.bg-wrap');

  if (bgWrap) {

    const bgTimeline = gsap.timeline({

      scrollTrigger: {
        trigger: ".bg-wrap",
        start: "top top",
        end: "+=400%",
        scrub: true,
        pin: true,
        // markers: true,
        // snap: {
        //   snapTo: 1 / (sections.length - 1), // snap to the closest .bg in the timeline
        //   duration: {min: 0.2, max: 0.5}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
        //   delay: 0.1, // wait 0.2 seconds from the last scroll event before doing the snapping
        //   ease: "none" // the ease of the snap animation ("power3" by default)
        // }
      }
    });

    let sections = gsap.utils.toArray(".bg");

    sections.forEach((el, i) => {

      if (sections[ i + 1 ]) {
        bgTimeline
          .to(el, {autoAlpha: 0})
          .to(sections[ i + 1 ], {autoAlpha: 1}, '<')
          .to(el.querySelector('.content'), {autoAlpha: 0, yPercent: -10}, '<')
          .from(sections[ i + 1 ].querySelector('.content'), {autoAlpha: 0, yPercent: 5}, '<')
      }
    });

  }
}

function progressLine() {
  const progress = document.querySelector('.progress');

  if (progress) {

    gsap.from('.progress', {
      height: 0,
      ease: 'none',
      scrollTrigger: { 
        trigger: ".timeline",
        scrub: true,
        once: true,
      }
    });

    const elements = document.querySelectorAll('.dot');
    elements.forEach((el) => {
        gsap.from(el, {
            autoAlpha: 0,
            scale: 4,
            scrollTrigger: {
                trigger: el,
                start: 'top center',
                end: 'top center',
            }
        })
    })
  }
  
}

function horizontalLine() {

  const elements = document.querySelectorAll('.points .wrapper span.horizontal');

  if (elements) {
    elements.forEach((el) => {
        gsap.from(el, {
            autoAlpha: 0,
            width: 0,
            scrollTrigger: {
                trigger: el,
                start: 'top 90%',
                end: 'top center',
                // toggleActions: 'play none none reverse',
                // markers: true
            }
        })
    })
  }

}

function init() {
  headingSlide();
  initFadeIn();
  initBG();
  initUnstick();
  // initUnstickFolders();
  initScrollBackground();
  progressLine();
  horizontalLine();
}

document.addEventListener('DOMContentLoaded', function(){
  init();
});
